import { api } from "@/main"
import { isEmpty } from "lodash"
import { statusTypes } from "@/store/modules/consts"
import { store } from "@/store/store"

function userRole () {
  return store.getters["soundsys/userRole"]
}

/* eslint-disable */
const ApiCalls = {
  getApiUrl() {
    return api.defaults.baseURL
  },
  /* vue setters*/
  setUser(data) {
    store.commit('soundsys/setUser', data)
    store.commit('members/setSociety', data.society)
  },
  setRightOwners(data) {
    store.commit('soundsys/setRightOwners', data)
  },
  setRights(data) {
    store.commit('soundsys/setRights', data)
  },
  setClaimers(data) {
    store.commit('soundsys/setClaimers', data)
  },
  setDataReady(data) {
    store.commit('soundsys/setDataReady', data)
  },
  /* API CALLS */
  recovery(data) {
    return new Promise((resolve, reject) =>
      api.post('users/recovery/', data).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  get_rights() {
    return new Promise((resolve, reject) =>
      api.get('rights/').then(
        resp => {
          resolve(resp.data)
        },
        err => reject(err)
      )
    )
  },
  rematch(id, fullMatch, releaseMatch) {
    return api.get(`playlistfiles/${id}/match/`, {params: {full_matching: fullMatch, ost_matching: releaseMatch}})
  },
  invalidate(id) {
    return api.post(`landingsoundrecordings/${id}/invalidate/`)
  },
  get_claimers() {
    return new Promise((resolve, reject) =>
      api.get('claimers/').then(
        resp => {
          resolve(resp.data.results)
        },
        err => reject(err)
      )
    )
  },
  get_right_owners() {
    return new Promise((resolve, reject) =>
      api.get('rightowners/').then(
        resp => {
          resolve(resp.data)
        },
        err => reject(err)
      )
    )
  },
  getUserDetail(id) {
    /*this works if member is deactivated for editing*/
    let url = 'users/' + id + '/data/'
    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err)
        }
      )
    )
  },
  resetPassword() {
    return new Promise((resolve, reject) =>
      api.get('users/resetpassword/').then(
        resp => {
          resolve(resp)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  login(data) {
    return new Promise((resolve, reject) =>
      api.post('users/login/', data).then(
        resp => {
          resolve(resp)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  getUser(id = null) {
    /* this will not work if memebr is deactivated*/
    let url = id === null ? 'users/info/' : 'users/' + id + '/data/'
    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {

          /* User must belong to an active PRODUCER */
          if (resp.data.member.status !== statusTypes.ACTIVE) {
            reject('MEMBER NOT ACTIVE')
          }
          resolve(resp.data)
        },
        err => {
          reject(err)
        }
      )
    )
  },
  blockUser(id) {
    let url = 'users/' + id + '/block/'

    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {
          resolve(resp.data)
        },
        err => reject(err.response.data)
      )
    )
  },
  activateUser(id) {
    let url = 'users/' + id + '/activate/'
    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {
          resolve(resp.data)
        },
        err => reject(err.response.data)
      )
    )
  },
  getLanguages() {
    let url = 'languages/'
    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  getMemberLanguages(...orgNames) {
    const qs = orgNames
      .map(name => `organization__name=${name}`)
      .join('&')

    let url = 'languages/?' + qs

    return new Promise((resolve, reject) =>
      api.get(url).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  getSocieties() {
    return new Promise((resolve, reject) =>
      api.get('societies/').then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  getMembers() {
    return new Promise((resolve, reject) =>
      api.get('members/').then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  activateMember(member_id) {
    return new Promise((resolve, reject) =>
      api.post('users/activate_member/', { member_id: member_id }).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  blockMember(member_id) {
    return new Promise((resolve, reject) =>
      api.post('users/block_member/', { member_id: member_id }).then(
        resp => {
          resolve(resp.data)
        },
        err => {
          reject(err.response.data)
        }
      )
    )
  },
  selectMatch(id, svId, type) {
    const url =
      type === 'usages' ? 'soundrecordingusages' : 'landingsoundrecordings'

    return api.post(`${url}/${id}/select_match/?single_view_id=${svId}`)
  },
  unclaim(id) {
    return api.post(`claims/${id}/unclaim/`)
  },

  generateUnmatchedReport (sheetIDs) {
    return api.post('soundrecordingusages/unmatched/', {"sheet_ids":  sheetIDs})
  },

  generatePreDistributionReport (sheetIDs) {
    return api.post('soundrecordingusages/pre_distribution/', {"sheet_ids":  sheetIDs})
  },

  uploadPicture(formData, user) {
    return new Promise((resolve, reject) =>
      api
        .post('users/' + user + '/avatar/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          resp => {
            resolve(resp.data)
          },
          err => {
            reject(err.response.data)
          }
        )
    )
  },
  uploadLogo(formData, member) {
    return new Promise((resolve, reject) =>
      api
        .post('members/' + member + '/logo/', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })
        .then(
          resp => {
            resolve(resp.data)
          },
          err => {
            reject(err.response.data)
          }
        )
    )
  },
  refreshUser() {
    this.getUser().then(
      user => {
        this.setUser(user)
      },
      err => {
        console.log('err', err)
        reject(err)
      }
    )
  },
  get_user_info() {
    return new Promise((resolve, reject) =>
      this.getUser().then(
        user => {
          this.setUser(user)
          localStorage.setItem('userRole', userRole(user))
          if (user && user.profile.member.org_type === 'MLC') {
            this.get_right_owners().then(rightOwners => {
              resolve(rightOwners)
            })
          } else {
            resolve([])
          }
        },
        err => {
          console.log('err', err)
          reject(err)
        }
      )
    )
  },
  save_user(data) {
    return new Promise((resolve, reject) =>
      api
        .post('users/save/', {
          user: data
        })
        .then(x => {
          this.get_user_info()
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  activate_user(token, state) {
    return new Promise((resolve, reject) =>
      api
        .post('users/' + token + '/', {
          state: state
        })
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  save_member(member) {
    return new Promise((resolve, reject) =>
      api
        .post('members/save/', member)
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  signUp(data) {
    return new Promise((resolve, reject) =>
      api
        .post('members/signup/', data)
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  saveRecord(data, url) {
    return api.post(url, data)
  },

  getUserStates(data) {
    let url = 'users/states/';

    return new Promise((resolve, reject) =>
      api
        .get(url, { params: data })
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  getMemberStates(data) {
    return new Promise((resolve, reject) =>
      api
        .get('memberslist/states/', { params: data })
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  getMember(id) {
    return new Promise((resolve, reject) =>
      api
        .get('memberslist/' + id + '/')
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  setMember(data) {
    return new Promise((resolve, reject) =>
      api
        .post('memberslist/', data)
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  getUserLang() {
    api.get('languages/user/').then(response => {
      store.dispatch('members/setLanguage', response.data);
    })
  },
  setUserLang(language) {
    return new Promise((resolve, reject) =>
      api.post('languages/save/', { language: language })
        .then(resp => {
          localStorage.setItem('lang', language);
          resolve(resp);
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  save_mandate(data) {
    return new Promise((resolve, reject) =>
      api
        .post('members/save_mandates/', data)
        .then(x => {
          resolve(x)
        })
        .catch(error => {
          reject(error.response.data)
        })
    )
  },
  claimSelected(data) {
    return api.post('soundrecordings/edit_claims/', data)
  },

  sendFile(file, url, type = 'put') {
    const formData = new FormData()
    formData.append('file', file)

    return api[type](url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  initial_setup() {
    return Promise.all([
      this.get_user_info(),
      this.get_rights(),
      this.get_claimers()
    ]).then(([
      userInfo,
      rights,
      claimers
    ]) => {
      if ( !isEmpty(userInfo) ) {
        this.setRightOwners(userInfo)
      }
      this.setRights(rights)

      this.setClaimers(claimers)
      store.dispatch('members/getLanguages')
      this.getUserLang()
    })
  }
}

function downloadFile(data, filename) {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename) // or any other extension
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
}

export { ApiCalls, downloadFile }
